import type { Graph } from '@/schema/estate';

export async function createCategory(
  g: Graph,
  opts: { estateId: string; name: string; groupId: string; author: string },
): Promise<string> {
  const id = crypto.randomUUID();
  const now = Date.now();
  await g.category.create({
    id,
    owner_group_id: opts.groupId,
    estate_id: opts.estateId,
    name: opts.name,
    created_at: now,
    updated_at: now,
    archived: false,
  });
  return id;
}

export function listCategories(g: Graph, estateId: string) {
  return g.category.all().filter((c) => c.estate_id === estateId && !c.archived);
}

export function findCategory(g: Graph, estateId: string, name: string) {
  const want = name.trim().toLowerCase();
  return listCategories(g, estateId).find((c) => c.name.trim().toLowerCase() === want);
}

/** The estate's live category with this name, ignoring case, or a new one when none matches. */
export async function resolveCategory(
  g: Graph,
  opts: { estateId: string; name: string; groupId: string; author: string },
): Promise<string> {
  const found = findCategory(g, opts.estateId, opts.name);
  return found ? found.id : createCategory(g, { ...opts, name: opts.name.trim() });
}
